var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ProductRequirementsModal',_vm._g(_vm._b({},'ProductRequirementsModal',{ product: _vm.product, updating: _vm.updating },false),{ submit: _vm.handleProductUpdate }))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }